import React, {
    useEffect,
    useRef,
    useState,
    useContext,
    useCallback,
} from "react";
import { getOpenOrders, cancelOrders } from "../api/apiCalls";
import {
    Paper,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Avatar,
    Grid,
} from "@mui/material";
import { Refresh, Delete } from "@mui/icons-material";
import GlobalContext from "../contexts/globalcontext";
import ClosedOrders from "./ClosedOrders";

const OpenOrders = () => {
    const { sbAlert, setTotalOrders } = useContext(GlobalContext);
    const firstLoad = useRef(true);
    const [openOrders, setOpenOrders] = useState([]);

    const sendCancelOrders = async (order_id, instrument_name) => {
        // console.log(order_id, instrument_name);
        await cancelOrders(order_id, instrument_name);
        await retrieveOpenOrders();
    };

    const retrieveOpenOrders = useCallback(
        async (msg = false) => {
            const data = await getOpenOrders();
            data.sort((a, b) => a.price - b.price);
            const newData = data.map((item) => {
                const mySplit = item.instrument_name.split("_");
                return { ...item, ico: mySplit[0].toLowerCase() };
            });
            setOpenOrders(newData);
            setTotalOrders(newData.length);
            // console.log(newData);
            if (msg) {
                sbAlert("Data Reloaded", "success");
            }
        },
        [sbAlert]
    );

    useEffect(() => {
        if (firstLoad.current === true) {
            retrieveOpenOrders();
            firstLoad.current = false;
        }
    }, [retrieveOpenOrders]);

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs="auto">
                    <TableContainer
                        component={Paper}
                        sx={{ minWidth: 600, maxWidth: 850 }}
                        elevation={5}
                    >
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={8}>
                                        <Typography variant="h6">
                                            <span>
                                                Open Orders ({openOrders.length}
                                                )
                                            </span>
                                            <span>
                                                <Button
                                                    onClick={() =>
                                                        retrieveOpenOrders(true)
                                                    }
                                                >
                                                    <Refresh />
                                                </Button>
                                            </span>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width="100px">
                                        Side
                                    </TableCell>
                                    <TableCell align="right"></TableCell>
                                    <TableCell align="left">
                                        Crypto Name
                                    </TableCell>
                                    <TableCell align="right">Price</TableCell>
                                    <TableCell align="right">Qty</TableCell>
                                    <TableCell align="right">
                                        Qty Done
                                    </TableCell>
                                    <TableCell align="right">Fees</TableCell>
                                    <TableCell align="center">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {openOrders.map((order) => (
                                    <TableRow key={order.order_id}>
                                        <TableCell
                                            align="center"
                                            component="th"
                                            scope="row"
                                        >
                                            {order.side === "BUY" ? (
                                                <Chip
                                                    label={order.side}
                                                    sx={{ width: "80px" }}
                                                    color="success"
                                                    size="small"
                                                />
                                            ) : (
                                                <Chip
                                                    label={order.side}
                                                    sx={{ width: "80px" }}
                                                    color="error"
                                                    size="small"
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Avatar
                                                src={`cryptoimg/${order.ico}.jpg`}
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            {order.instrument_name}
                                        </TableCell>
                                        <TableCell align="right">
                                            {order.price}
                                        </TableCell>
                                        <TableCell align="right">
                                            {order.quantity}
                                        </TableCell>
                                        <TableCell align="right">
                                            {order.cumulative_quantity}
                                        </TableCell>
                                        <TableCell align="right">
                                            {order.fee_currency}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                onClick={() =>
                                                    sendCancelOrders(
                                                        order.order_id,
                                                        order.instrument_name
                                                    )
                                                }
                                            >
                                                <Delete
                                                    color="error"
                                                    sx={{
                                                        height: "20px",
                                                        width: "20px",
                                                    }}
                                                />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs="auto">
                    <ClosedOrders openOrders={openOrders} />
                </Grid>
            </Grid>
        </div>
    );
};

export default OpenOrders;
